import { DeviceModel } from './device.model';
import { CommonInfoService } from '../cart-process/common-info.service';
import { IBundle, IDevice } from '../interfaces/cart-details.interface';

export class AccessorySecondPageModel extends DeviceModel {
  constructor(bundle: IBundle, accessory: IDevice, commonInfo: CommonInfoService) {
    super(accessory, commonInfo);

  }
}
